import t from '@instructure/quiz-i18n/es/format-message';
export var listSize = function listSize(defaultList, options) {
  var minMessage = options.minMessage || t('too few items');
  var maxMessage = options.maxMessage || t('too many items');
  var list = options.listOverride || defaultList;
  // if allowNullOrUndefined is falsey then ignore the rule
  // of the rules if the list is null or undefined
  var listNullOrUndefined = list === null || list === void 0;
  if (options.allowNullOrUndefined && listNullOrUndefined) {
    return;
  }
  if (options.min && (listNullOrUndefined || list.length < options.min)) {
    return minMessage;
  }
  if (options.max && list.length > options.max) {
    return maxMessage;
  }
};
export default listSize;